import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LOGIN_TYPES } from 'src/app/modules/login/models/login-types';
import { LOCAL_STORAGE_KEYS } from '../models/local-storage-keys';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private _router: Router, private _authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.guardDefaultBehaviour(next, state);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.guardDefaultBehaviour(next, state);
  }

  private getDefaultUrl(): UrlTree {
    const isExternalUser = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE) === LOGIN_TYPES.EXTERNAL;
    return this._router.parseUrl(isExternalUser ? '/loginext' : '/login');
  }

  private guardDefaultBehaviour(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this._authService.setRedirectLoginUrl(state.url);
    if (this._authService.isLoggedIn()) {
      return true;
    } else {
      return this.getDefaultUrl();
    }
  }

}
